import { render } from "./PlanCard.vue?vue&type=template&id=19bf1a0e&scoped=true&ts=true"
import script from "./PlanCard.vue?vue&type=script&lang=ts"
export * from "./PlanCard.vue?vue&type=script&lang=ts"

import "./PlanCard.vue?vue&type=style&index=0&id=19bf1a0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bf1a0e"]])

export default __exports__